
const digest = '08d085001ef0fd695077214660d728efb5c7b50454146ea089811f46465c3cfe';
const classes = {"wrapper":"_wrapper_1jdu3_1"};
const css = `._wrapper_1jdu3_1 {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: -34px -24px;
  border-bottom-left-radius: 20px;
  border-bottom-right-radius: 20px;
  background: rgb(220, 233, 250);
  padding: 24px 24px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  